export default class MonitoringReportV1ViewModel {
    // IMPLEMENTATION
    travelPlanType: string | null = null;
    travelPLanCoordinator: string | null = null
    coordinatorShiftType: string | null = null
    monthImplemeted: number | null = null
    yearImplemeted: number | null = null

    // SPLITS
    modeSplitObtainedPrior: string | null = null;
    modeSplitMonth: number | null = null;
    modeSplitYear: number | null = null;
    modeSplitVehicle: number | null = null;
    modeSplitCyclist: number | null = null;
    modeSplitPublicTransport: number | null = null;
    modeSplitPedestrians: number | null = null;
    targetsIdentified: string | null = null;
    targetsMonth: number | null = null;
    targetsYear: number | null = null;
    targetsVehicle: number | null = null;
    targetsCyclist: number | null = null;
    targetsPublicTransport: number | null = null;
    targetsPedestrians: number | null = null;
    targetGroupStaff: string | null = null;
    targetGroupVisitors: string | null = null;
    targetGroupCustomers: string | null = null;
    targetGroupStudents: string | null = null;
    targetGroupPatients: string | null = null;
    targetGroupAllSiteUsers: string | null = null;
    targetGroupOther: string | null = null;
    targetGroupOtherText: string | null = null;
    modeSplitsComments: string | null = null;

    // SITE DETAILS
    description: string | null = null;
    street: string | null = null;
    district: string | null = null;
    town: string | null = null;
    postalCode: string | null = null;
    location: string | null = null;
    subCategory: string | null = null;
    latitude: number | null = null;
    longitude: number | null = null;
    developmentName: string | null = null;
    totPar1: number | null = null;
    totPar1Unit: string | null = null;
    totPar1abbreviation: string | null = null;
    totPar2: number | null = null;
    totPar2abbreviation: string | null = null;
    detachedPrivate: number | null = null;
    detachedNonPrivate: number | null = null;
    detachedTotal: number | null = null;
    semiDetachedPrivate: number | null = null;
    semiDetachedNonPrivate: number | null = null;
    semiDetachedTotal: number | null = null;
    terracedPrivate: number | null = null;
    terracedNonPrivate: number | null = null;
    terracedTotal: number | null = null;
    bungalowPrivate: number | null = null;
    bungalowNonPrivate: number | null = null;
    bungalowTotal: number | null = null;
    flatHousePrivate: number | null = null;
    flatHouseNonPrivate: number | null = null;
    flatHouseTotal: number | null = null;
    flatBlockPrivate: number | null = null;
    flatBlockNonPrivate: number | null = null;
    flatBlockTotal: number | null = null;
    townhousePrivate: number | null = null;
    townhouseNonPrivate: number | null = null;
    townhouseTotal: number | null = null;
    residentialUnitsOther: string | null = null;
    residentialUnitsAveragePerUnit: number | null = null;
    openSince: number | null = null;
    parkingTotal: number | null = null;
    parkingOnStreet: number | null = null;
    parkingDriveways: number | null = null;
    parkingGarage: number | null = null;
    parkingCommunal: number | null = null;
    parkingAllocated: number | null = null;
    parkingElectric: number | null = null;
    changesFromPrevious: string | null = null;

    // FEATURES - Cycling
    coveredCycleRacks: string | null = null;
    coveredCycleRacksMonth: number | null = null;
    coveredCycleRacksYear: number | null = null;
    lockers: string | null = null;
    lockersMonth: number | null = null;
    lockersYear: number | null = null;
    cctvCycleParking: string | null = null;
    cctvCycleParkingMonth: number | null = null;
    cctvCycleParkingYear: number | null = null;
    networkOfRoutes: string | null = null;
    networkOfRoutesMonth: number | null = null;
    networkOfRoutesYear: number | null = null;
    goodLightingCycleParking: string | null = null;
    goodLightingCycleParkingMonth: number | null = null;
    goodLightingCycleParkingYear: number | null = null;
    secureCycleParking: string | null = null;
    secureCycleParkingMonth: number | null = null;
    secureCycleParkingYear: number | null = null;
    showerChangingFacilities: string | null = null;
    showerChangingFacilitiesMonth: number | null = null;
    showerChangingFacilitiesYear: number | null = null;
    cyclingComment: string | null = null;

    // Financial
    cashOutPayment: string | null = null;
    cashOutPaymentMonth: number | null = null;
    cashOutPaymentYear: number | null = null;
    travelSeasonLoan: string | null = null;
    travelSeasonLoanMonth: number | null = null;
    travelSeasonLoanYear: number | null = null;
    waiveParkingPermit: string | null = null;
    waiveParkingPermitMonth: number | null = null;
    waiveParkingPermitYear: number | null = null;
    financialComment: string | null = null;

    // Public Transport
    busWaitingFacilities: string | null = null;
    busWaitingFacilitiesMonth: number | null = null;
    busWaitingFacilitiesYear: number | null = null;
    securePedestrianBusStop: string | null = null;
    securePedestrianBusStopMonth: number | null = null;
    securePedestrianBusStopYear: number | null = null;
    publicTransportInfo: string | null = null;
    publicTransportInfoMonth: number | null = null;
    publicTransportInfoYear: number | null = null;
    journeyPlanningHelp: string | null = null;
    journeyPlanningHelpMonth: number | null = null;
    journeyPlanningHelpYear: number | null = null;
    newBusServices: string | null = null;
    newBusServicesMonth: number | null = null;
    newBusServicesYear: number | null = null;
    securePedestrianRailStation: string | null = null;
    securePedestrianRailStationMonth: number | null = null;
    securePedestrianRailStationYear: number | null = null;
    publicTransportAwareness: string | null = null;
    publicTransportAwarenessMonth: number | null = null;
    publicTransportAwarenessYear: number | null = null;
    publicTransportComment: string | null = null;

    // Car Sharing
    carShareMatching: string | null = null;
    carShareMatchingMonth: number | null = null;
    carShareMatchingYear: number | null = null;
    priorityParkingCarSharers: string | null = null;
    priorityParkingCarSharersMonth: number | null = null;
    priorityParkingCarSharersYear: number | null = null;
    freeRideHomeCarSharers: string | null = null;
    freeRideHomeCarSharersMonth: number | null = null;
    freeRideHomeCarSharersYear: number | null = null;
    carClubAvailable: string | null = null;
    carClubOperatedBySite: string | null = null;
    carSharingComment: string | null = null;

    // Car Parking
    limitedOnSiteParking: string | null = null;
    parkingChargesTargetGroups: string | null = null;
    parkingChargesTargetGroupsMonth: number | null = null;
    parkingChargesTargetGroupsYear: number | null = null;
    permitOnlyParking: string | null = null;
    permitOnlyParkingMonth: number | null = null;
    permitOnlyParkingYear: number | null = null;
    parkingManagement: string | null = null;
    parkingManagementMonth: number | null = null;
    parkingManagementYear: number | null = null;
    carParkingComment: string | null = null;

    // Shuttle Bus
    shuttleToWorkAreas: string | null = null;
    shuttleToWorkAreasMonth: number | null = null;
    shuttleToWorkAreasYear: number | null = null;
}


